import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  height: 100%;
  min-width: 0;
}

.dashboard-page {
  --blue: #1668c8;
  --ink: #182b43;
  --muted: #748296;
  --line: #e5ebf2;
  width: 100%;
  max-width: 1440px;
  min-height: 100%;
  margin: 0 auto;
  padding: 30px 40px 24px;
  background: #f5f8fc;
  color: var(--ink);
  font-family: "Pretendard Variable", Pretendard, "Noto Sans KR", sans-serif;
  font-size: 13px;
  box-sizing: border-box;
}

.dashboard-page *, .dashboard-page *::before, .dashboard-page *::after {
  box-sizing: border-box;
}

h1, h2, h3, p {
  margin: 0;
}

button, input {
  font: inherit;
}

button {
  cursor: pointer;
}

button:disabled {
  cursor: wait;
  opacity: 0.6;
}

button:focus-visible, input:focus-visible, [tabindex]:focus-visible {
  outline: 3px solid #88b5ec;
  outline-offset: 3px;
}

.dashboard-heading, .dashboard-title-row, .dashboard-heading-actions, .dashboard-metric-label,
.dashboard-panel-heading, .dashboard-category-toolbar, .dashboard-source-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.dashboard-heading {
  margin-bottom: 24px;
  align-items: flex-end;
}

.dashboard-breadcrumb {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  color: var(--muted);
  font-size: 12px;
}

.dashboard-breadcrumb i {
  font-size: 8px;
  color: #a2afbd;
}

.dashboard-breadcrumb [aria-current] {
  color: #3d546f;
}

.dashboard-title-row {
  justify-content: flex-start;
}

h1 {
  font-size: 27px;
  font-weight: 750;
  letter-spacing: -1px;
  line-height: 1.35;
}

.dashboard-heading p {
  margin-top: 8px;
  color: #6b7b8f;
  line-height: 1.6;
}

.dashboard-agent-badge {
  padding: 4px 9px;
  background: #e4effd;
  color: var(--blue);
  border: 1px solid #d2e4fa;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
}

.dashboard-heading-actions {
  flex-shrink: 0;
}

.dashboard-updated {
  color: var(--muted);
  font-size: 11px;
}

.dashboard-refresh {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border: 1px solid #d5e0ed;
  border-radius: 8px;
  color: #425d7a;
  background: white;
  font-weight: 600;
}

.dashboard-refresh:hover {
  background: #edf4fd;
  border-color: #adc9ed;
}

.dashboard-notice {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
  padding: 14px 18px;
  border: 1px solid #efd5a1;
  border-radius: 10px;
  background: #fff9ec;
  color: #815b1b;
  line-height: 1.6;
}

.dashboard-notice p {
  flex: 1;
}

.dashboard-notice button {
  margin-left: auto;
  flex-shrink: 0;
  padding: 6px 10px;
  border: 1px solid #dfc287;
  background: white;
  border-radius: 6px;
  color: inherit;
}

.dashboard-loading {
  min-height: 320px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  color: #6b7b8f;
}

.dashboard-spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #d7e6f6;
  border-top-color: var(--blue);
  border-radius: 50%;
  animation: dashboard-spin 0.9s linear infinite;
}

.is-spinning {
  animation: dashboard-spin 0.9s linear infinite;
}

@keyframes dashboard-spin {
  to {
    transform: rotate(360deg);
  }
}
.dashboard-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 22px;
}

.dashboard-metric {
  border: 1px solid var(--line);
  border-radius: 12px;
  background: white;
  padding: 19px 21px 17px;
  box-shadow: 0 2px 3px rgba(33, 58, 91, 0.0078431373);
}

.dashboard-metric-label {
  font-weight: 600;
  color: #576c84;
}

.dashboard-metric-label i {
  color: #4f8cce;
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #eff5fd;
  font-size: 13px;
}

.dashboard-metric-value {
  display: flex;
  align-items: baseline;
  gap: 7px;
  margin: 4px 0 8px;
}

.dashboard-metric-value strong {
  color: #1c3656;
  font-size: 32px;
  line-height: 1.25;
  letter-spacing: -0.7px;
  font-variant-numeric: tabular-nums;
}

.dashboard-metric-value span {
  color: #7b8b9d;
  font-size: 12px;
}

.dashboard-metric p {
  color: #8793a3;
  font-size: 11px;
  line-height: 1.5;
}

.dashboard-overview-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.65fr) minmax(0, 1fr);
  align-items: stretch;
  gap: 20px;
  margin-bottom: 20px;
}

.dashboard-panel {
  min-width: 0;
  background: white;
  border: 1px solid var(--line);
  border-radius: 12px;
}

.dashboard-panel-heading {
  padding: 21px 23px 17px;
  align-items: flex-start;
}

h2 {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.4px;
}

.dashboard-panel-heading p:not(.dashboard-eyebrow) {
  margin-top: 5px;
  color: #8190a3;
  font-size: 11px;
  line-height: 1.6;
}

.dashboard-eyebrow {
  margin-bottom: 7px;
  font-size: 9px;
  letter-spacing: 1.4px;
  color: #7196bf;
  font-weight: 700;
}

.dashboard-scope {
  display: flex;
  flex-shrink: 0;
  padding: 3px;
  background: #f0f4f9;
  border-radius: 7px;
  gap: 2px;
}

.dashboard-scope button {
  border: 0;
  border-radius: 5px;
  padding: 7px 10px;
  background: transparent;
  color: #7c8c9f;
  font-size: 11px;
  white-space: nowrap;
}

.dashboard-scope button[aria-pressed=true] {
  background: white;
  color: var(--blue);
  box-shadow: 0 1px 4px rgba(36, 75, 124, 0.0941176471);
  font-weight: 700;
}

.dashboard-categories {
  display: flex;
  flex-direction: column;
}

.dashboard-category-toolbar {
  margin: 0 23px 15px;
  padding: 12px 0;
  border-top: 1px solid #eef2f7;
  border-bottom: 1px solid #eef2f7;
}

.dashboard-scope-total {
  color: #7d8ca0;
  font-size: 12px;
}

.dashboard-scope-total strong {
  margin: 0 5px 0 10px;
  color: var(--ink);
  font-size: 15px;
  font-variant-numeric: tabular-nums;
}

.dashboard-search {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #9aabbd;
}

.dashboard-search input {
  width: 114px;
  min-width: 0;
  padding: 4px 0;
  border: 0;
  background: transparent;
  color: #445f7d;
  font-size: 11px;
}

.dashboard-search input::placeholder {
  color: #94a5b8;
}

.dashboard-category-chart {
  display: grid;
  gap: 13px;
  padding: 0 23px 20px;
  flex: 1;
}

.dashboard-category-row {
  display: grid;
  grid-template-columns: 68px minmax(0, 1fr) 55px 43px;
  align-items: center;
  gap: 12px;
  min-height: 14px;
}

.dashboard-category-label {
  color: #61748c;
  font-size: 12px;
}

.dashboard-bar-track {
  height: 9px;
  background: #f0f4f8;
  border-radius: 3px;
  overflow: hidden;
}

.dashboard-bar-track span {
  display: block;
  height: 100%;
  border-radius: 3px;
  background: linear-gradient(90deg, #4692da, #196bc5);
  transition: width 0.25s ease;
}

.dashboard-bar-track .is-sample {
  background: linear-gradient(90deg, #7dcac4, #419d9b);
}

.dashboard-category-row strong {
  font-size: 12px;
  font-weight: 650;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.dashboard-category-row small {
  color: #93a1b2;
  text-align: right;
  font-size: 10px;
}

.dashboard-panel-note {
  display: flex;
  gap: 7px;
  align-items: flex-start;
  padding: 12px 23px;
  border-top: 1px solid #eef2f7;
  color: #8695a7;
  font-size: 10px;
  line-height: 1.7;
}

.dashboard-panel-note i {
  margin-top: 3px;
  color: #91abc7;
}

.dashboard-side-panels {
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 18px;
  min-width: 0;
}

.dashboard-type-content {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 6px 23px 24px;
  min-height: 160px;
}

.dashboard-donut {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: 126px;
  height: 126px;
  border-radius: 50%;
}

.dashboard-donut > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 94px;
  height: 94px;
  border-radius: 50%;
  background: white;
  gap: 2px;
}

.dashboard-donut strong {
  font-size: 23px;
  letter-spacing: -0.5px;
  font-variant-numeric: tabular-nums;
}

.dashboard-donut span {
  font-size: 10px;
  color: #91a0b2;
}

.dashboard-type-legend {
  flex: 1;
  min-width: 0;
  list-style: none;
  display: grid;
  gap: 11px;
  margin: 0;
  padding: 0;
}

.dashboard-type-legend li {
  display: grid;
  grid-template-columns: 6px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 7px;
  font-size: 11px;
  color: #6a7c92;
}

.dashboard-legend-dot {
  width: 6px;
  height: 6px;
  border-radius: 2px;
}

.dashboard-type-legend strong {
  color: #435b76;
  font-weight: 650;
}

.dashboard-type-legend small {
  font-size: 9px;
  color: #9aa7b8;
  min-width: 31px;
  text-align: right;
}

.dashboard-trend-total {
  padding: 3px 7px;
  background: #eef5fd;
  color: #4082c7;
  border-radius: 5px;
  font-size: 11px;
  white-space: nowrap;
}

.dashboard-trend-chart {
  display: flex;
  height: 128px;
  gap: 16px;
  padding: 16px 25px 0;
}

.dashboard-trend-column {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.dashboard-trend-track {
  width: 100%;
  height: 88px;
  display: flex;
  align-items: flex-end;
  border-bottom: 1px solid #e6edf5;
}

.dashboard-trend-bar {
  position: relative;
  width: 100%;
  min-height: 2px;
  max-width: 35px;
  margin: 0 auto;
  background: #96bde8;
  border-radius: 4px 4px 0 0;
}

.dashboard-trend-column:last-child .dashboard-trend-bar {
  background: #2778cc;
}

.dashboard-trend-bar span {
  position: absolute;
  bottom: calc(100% + 5px);
  left: 50%;
  transform: translateX(-50%);
  color: #6b87a8;
  font-size: 9px;
}

.dashboard-trend-column small {
  font-size: 10px;
  color: #99a6b7;
  margin-top: 10px;
}

.dashboard-trend-note {
  padding: 12px 23px 17px;
  font-size: 10px;
  color: #98a4b4;
  line-height: 1.6;
}

.dashboard-empty {
  color: #8797ab;
  text-align: center;
  padding: 24px 8px;
  font-size: 12px;
  line-height: 1.7;
}

.dashboard-empty-note {
  margin: 0 23px 14px;
  padding: 10px;
  border-radius: 6px;
  color: #8295ab;
  background: #f7f9fc;
  text-align: center;
  font-size: 11px;
}

.dashboard-category-table-panel {
  margin-bottom: 20px;
}

.dashboard-muted {
  color: #98a5b6;
  font-size: 11px;
  white-space: nowrap;
}

.dashboard-table-scroll {
  overflow-x: auto;
  margin: 0 23px 20px;
}

.dashboard-category-table {
  width: 100%;
  border-collapse: collapse;
  text-align: right;
  white-space: nowrap;
  font-size: 12px;
}

.dashboard-category-table th, .dashboard-category-table td {
  padding: 11px 17px;
  border-bottom: 1px solid #edf1f6;
  font-variant-numeric: tabular-nums;
}

.dashboard-category-table th:first-child {
  text-align: left;
}

.dashboard-category-table thead th {
  background: #f6f8fb;
  color: #7d8da2;
  font-size: 11px;
  font-weight: 500;
}

.dashboard-category-table tbody th {
  font-weight: 500;
  color: #5f738d;
}

.dashboard-category-table td {
  color: #526982;
}

.dashboard-category-table tbody tr:hover {
  background: #f8fbff;
}

.dashboard-category-table tfoot {
  background: #f5f9fe;
}

.dashboard-category-table tfoot th, .dashboard-category-table tfoot td {
  color: #37618e;
  font-weight: 700;
  border-bottom: none;
}

.dashboard-source-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin: 0 23px 22px;
}

.dashboard-source-card {
  border: 1px solid var(--line);
  border-radius: 9px;
  padding: 17px;
  background: #fcfdff;
}

.dashboard-source-card h3 {
  font-size: 12px;
  color: #506a87;
  font-weight: 600;
}

.dashboard-source-state {
  border-radius: 5px;
  padding: 3px 6px;
  background: #edf4fd;
  color: #688eb7;
  font-size: 10px;
}

.dashboard-source-count {
  display: block;
  margin: 11px 0 7px;
  font-size: 23px;
  color: #355371;
}

.dashboard-source-count small {
  font-size: 11px;
  margin-left: 6px;
  color: #8196ad;
  font-weight: 400;
}

.dashboard-source-card p {
  font-size: 11px;
  color: #8b9baf;
  line-height: 1.7;
}

.dashboard-latest {
  color: #92a1b4;
  font-size: 10px;
  text-align: right;
  line-height: 1.7;
}

.dashboard-latest strong {
  display: block;
  color: #637f9e;
  font-weight: 500;
}

.dashboard-footer {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding-top: 18px;
  color: #98a6b8;
  font-size: 10px;
  line-height: 1.8;
}

.dashboard-footer i {
  margin-right: 5px;
  color: #85a2c0;
}

@media (min-width: 1500px) {
  .dashboard-page {
    padding-top: 36px;
  }
}
@media (max-width: 1150px) {
  .dashboard-page {
    padding: 26px 24px;
  }
  .dashboard-panel-heading {
    flex-wrap: wrap;
  }
  .dashboard-type-content {
    gap: 14px;
    padding-left: 18px;
    padding-right: 18px;
  }
  .dashboard-donut {
    width: 100px;
    height: 100px;
  }
  .dashboard-donut > div {
    width: 76px;
    height: 76px;
  }
  .dashboard-donut strong {
    font-size: 19px;
  }
  .dashboard-category-row {
    gap: 8px;
    grid-template-columns: 62px minmax(0, 1fr) 45px 38px;
  }
}
@media (max-width: 850px) {
  .dashboard-heading {
    align-items: flex-start;
  }
  .dashboard-heading-actions {
    flex-direction: column-reverse;
    align-items: flex-end;
    gap: 8px;
  }
  .dashboard-overview-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .dashboard-side-panels {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: auto;
  }
  .dashboard-category-chart {
    gap: 16px;
  }
  .dashboard-metrics {
    gap: 10px;
  }
  .dashboard-metric {
    padding: 15px;
  }
  .dashboard-metric-value strong {
    font-size: 26px;
  }
  .dashboard-metric p {
    min-height: 32px;
  }
  .dashboard-footer {
    flex-direction: column;
    gap: 5px;
  }
}
@media (max-width: 600px) {
  .dashboard-page {
    padding: 22px 16px;
  }
  h1 {
    font-size: 24px;
  }
  .dashboard-heading {
    gap: 8px;
    margin-bottom: 18px;
  }
  .dashboard-heading p {
    max-width: 230px;
    font-size: 12px;
  }
  .dashboard-heading-actions {
    padding-top: 32px;
  }
  .dashboard-updated {
    display: none;
  }
  .dashboard-refresh {
    padding: 9px;
  }
  .dashboard-refresh span {
    display: none;
  }
  .dashboard-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-bottom: 16px;
  }
  .dashboard-metric p {
    min-height: 0;
    font-size: 10px;
  }
  .dashboard-metric-label {
    gap: 5px;
    font-size: 12px;
  }
  .dashboard-metric-value strong {
    font-size: 28px;
  }
  .dashboard-metric-label i {
    width: 24px;
    height: 24px;
    font-size: 11px;
  }
  .dashboard-overview-grid {
    gap: 16px;
  }
  .dashboard-panel-heading {
    padding: 18px 17px 15px;
  }
  h2 {
    font-size: 15px;
  }
  .dashboard-categories .dashboard-panel-heading {
    gap: 16px;
  }
  .dashboard-scope {
    width: 100%;
  }
  .dashboard-scope button {
    flex: 1;
    padding: 9px;
  }
  .dashboard-category-toolbar {
    margin-left: 17px;
    margin-right: 17px;
  }
  .dashboard-search input {
    width: 90px;
  }
  .dashboard-category-chart {
    padding-left: 17px;
    padding-right: 17px;
  }
  .dashboard-category-row {
    grid-template-columns: 56px minmax(0, 1fr) 43px 34px;
    gap: 7px;
  }
  .dashboard-category-label {
    font-size: 11px;
  }
  .dashboard-category-row strong {
    font-size: 11px;
  }
  .dashboard-category-row small {
    font-size: 9px;
  }
  .dashboard-panel-note {
    padding-left: 17px;
    padding-right: 17px;
  }
  .dashboard-side-panels {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }
  .dashboard-type-content {
    padding: 5px 22px 22px;
    gap: 26px;
  }
  .dashboard-donut {
    width: 120px;
    height: 120px;
  }
  .dashboard-donut > div {
    width: 90px;
    height: 90px;
  }
  .dashboard-table-scroll {
    margin-left: 17px;
    margin-right: 17px;
  }
  .dashboard-category-table {
    min-width: 470px;
  }
  .dashboard-category-table th, .dashboard-category-table td {
    padding: 10px;
  }
  .dashboard-source-grid {
    grid-template-columns: minmax(0, 1fr);
    margin-left: 17px;
    margin-right: 17px;
    gap: 12px;
  }
  .dashboard-notice {
    align-items: flex-start;
    flex-wrap: wrap;
  }
}
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation: none !important;
    transition: none !important;
  }
}
.dashboard-qdrant {
  margin-bottom: 20px;
}

.dashboard-qdrant-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin: 0 23px 15px;
}

.dashboard-qdrant-metrics > div {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 14px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #f8fbff;
}

.dashboard-qdrant-metrics span {
  color: #70869d;
  font-size: 11px;
}

.dashboard-qdrant-metrics strong {
  font-size: 23px;
  color: #355371;
  font-variant-numeric: tabular-nums;
}

.dashboard-qdrant-metrics small {
  font-size: 11px;
  font-weight: 400;
  margin-left: 5px;
}

.dashboard-qdrant-note {
  margin: 0 23px 16px;
  color: #70869d;
  font-size: 11px;
  line-height: 1.7;
}

@media (max-width: 600px) {
  .dashboard-qdrant-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-left: 17px;
    margin-right: 17px;
  }
  .dashboard-qdrant-note {
    margin-left: 17px;
    margin-right: 17px;
  }
}`],
})
export class PageDashboardComponent implements OnInit {
    public loading = false;
    public overviewError = '';
    public data: any = null;
    public loadedAt = '';
    public scope = 'documents';
    public categoryQuery = '';
    public readonly colors = ['#1668c8', '#52a7dc', '#75c4bf', '#8b9fd3', '#b4c7dc', '#dae4ef'];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load(refresh = false) {
        if (this.loading) return;
        this.loading = true;
        this.overviewError = '';
        await this.service.render();
        try {
            const response: any = await wiz.call('overview', { refresh: refresh ? '1' : '0' });
            const data = response?.data;
            if (response?.code !== 200 || !data?.summary || !Array.isArray(data.categoryRows)) {
                throw new Error('invalid overview');
            }
            this.data = data;
            this.loadedAt = new Intl.DateTimeFormat('ko-KR', {
                month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
                hour12: false, timeZone: 'UTC'
            }).format(new Date());
        } catch (_) {
            this.overviewError = this.data
                ? '최신 집계를 불러오지 못했습니다. 마지막으로 확인한 현황을 표시합니다.'
                : '데이터 현황을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async setScope(scope: string) {
        this.scope = scope;
        await this.service.render();
    }

    public async setCategoryQuery(query: string) {
        this.categoryQuery = query;
        await this.service.render();
    }

    public documentsUnavailable(): boolean {
        return ['error', 'blocked'].includes(this.data?.diagnostics?.status);
    }

    public scopeLabel(): string {
        return this.scope === 'documents' ? '지식 문서' : '구조화 샘플';
    }

    public scopeUnit(): string {
        return this.scope === 'documents' ? '개' : '건';
    }

    public scopeTotal(): number {
        return this.number(this.scope === 'documents'
            ? this.data?.summary?.documentCount : this.data?.summary?.sampleRecords);
    }

    public categoryCount(row: any): number {
        return this.number(this.scope === 'documents' ? row.documentCount : row.sampleRecords);
    }

    public categoryRows(): any[] {
        const query = this.categoryQuery.trim().toLocaleLowerCase();
        return (this.data?.categoryRows || []).filter((row: any) =>
            !query || String(row.label || '').toLocaleLowerCase().includes(query));
    }

    public categoryWidth(row: any): number {
        const largest = Math.max(0, ...(this.data?.categoryRows || []).map((item: any) => this.categoryCount(item)));
        return largest ? this.categoryCount(row) / largest * 100 : 0;
    }

    public categoryPercent(row: any): string {
        return this.scopeTotal() ? (this.categoryCount(row) / this.scopeTotal() * 100).toFixed(1) : '0.0';
    }

    public categoryAria(row: any): string {
        if (this.scope === 'documents' && this.documentsUnavailable()) return row.label + ': 집계 확인 필요';
        return row.label + ': ' + this.formatNumber(this.categoryCount(row)) + this.scopeUnit();
    }

    public typeRows(): any[] {
        return (this.data?.typeRows || []).filter((row: any) => row.scope === this.scope && this.number(row.count) > 0);
    }

    public typeTotal(): number {
        return this.typeRows().reduce((total: number, row: any) => total + this.number(row.count), 0);
    }

    public typePercent(row: any): string {
        return this.typeTotal() ? (this.number(row.count) / this.typeTotal() * 100).toFixed(1) : '0.0';
    }

    public donutBackground(): string {
        const total = this.typeTotal();
        if (!total || (this.scope === 'documents' && this.documentsUnavailable())) return '#edf1f6';
        let start = 0;
        const stops = this.typeRows().map((row: any, index: number) => {
            const end = start + this.number(row.count) / total * 100;
            const stop = this.colors[index % this.colors.length] + ' ' + start + '% ' + end + '%';
            start = end;
            return stop;
        });
        return 'conic-gradient(' + stops.join(', ') + ')';
    }

    public trendRows(): any[] {
        return this.data?.trendRows || [];
    }

    public trendHeight(row: any): number {
        const largest = Math.max(0, ...this.trendRows().map((item: any) => this.number(item.count)));
        return largest ? this.number(row.count) / largest * 100 : 0;
    }

    public trendTotal(): number {
        return this.trendRows().reduce((total: number, row: any) => total + this.number(row.count), 0);
    }

    public summaryCards(): any[] {
        const summary = this.data?.summary || {};
        const unavailable = this.documentsUnavailable();
        return [
            { id: 'documentCount', label: '지식 문서', value: unavailable ? '—' : this.formatNumber(summary.documentCount), unit: '개', icon: 'fa-file-lines', detail: this.data?.qdrant?.summary ? '첨부 문서·승인 문서의 고유 파일' : 'Agent가 검색할 수 있는 승인 문서' },
            { id: 'referenceChunks', label: '검색 참조 청크', value: unavailable ? '—' : this.formatNumber(summary.referenceChunks), unit: '개', icon: 'fa-layer-group', detail: this.data?.qdrant?.summary ? '파일별 대표 적재본의 콘텐츠 청크' : '문서에서 분할한 검색 단위' },
            { id: 'sampleRecords', label: '구조화 샘플', value: this.formatNumber(summary.sampleRecords), unit: '건', icon: 'fa-database', detail: 'Agent 조회·분석용 샘플 레코드' },
            { id: 'categoryCount', label: '데이터 대분류', value: this.formatNumber(summary.categoryCount), unit: '개', icon: 'fa-shapes', detail: '데이터가 등록된 대분류' },
        ];
    }

    public qdrantCount(value: any): string {
        return value === null || value === undefined ? '—' : this.formatNumber(value);
    }

    public displayCount(value: any, documents = false): string {
        return documents && this.documentsUnavailable() ? '—' : this.formatNumber(value);
    }

    public number(value: any): number {
        const result = Number(value);
        return Number.isFinite(result) ? Math.max(0, result) : 0;
    }

    public formatNumber(value: any): string {
        return new Intl.NumberFormat('ko-KR').format(this.number(value));
    }

    public formatDate(value: any): string {
        if (!value || value === '-') return '기록 없음';
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? '기록 없음'
            : new Intl.DateTimeFormat('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'UTC' }).format(date);
    }
}

export default PageDashboardComponent;